import qs from 'qs';
import axios from "axios";
import {SCROLL_OFFSET} from "../wpconfig";

// 숫자 타입에서 쓸 수 있도록 format() 함수 추가
Number.prototype.format = function () {
	if (this == 0) return 0;

	var reg = /(^[+-]?\d+)(\d{3})/;
	var n = (this + '');

	while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');

	return n;
};

// 문자열 타입에서 쓸 수 있도록 format() 함수 추가
String.prototype.format = function () {
	var num = parseFloat(this);
	if (isNaN(num)) return "0";

	return num.format();
};

export function getNumberFormat(number) {
	if (number)
		return number.format();
	else
		return 0;
}

export function getSelectFormat(result) {
	let r = [];
	result.map((ca) => {
		let temp = {};
		if (ca.title && ca.title != ' ') {
			temp.name = ca.title;
			temp.name = ca.title + ' (' + ca.count + ')';
			temp.value = ca.title;
			if (ca.sub_category) {
				let tempArray = [];
				ca.sub_category.map((ca2) => {
					let t = {};
					t.name = ca2.title + ' (' + ca2.count + ')';
					t.value = ca2.title;
					tempArray.push(t)
				})
				if (tempArray.length > 0)
					temp.children = tempArray;
			}

			r.push(temp);
		}
	});
	return r;
}

export function getDateFormat(date) {
	return date.substr(0, 4) + '.' + date.substr(4, 2);
}

export function getDateDottedFormat(date) {
	return getDateFormat(date);
}

export function getParams(key) {
	const query = qs.parse(window.location.search, {
		ignoreQueryPrefix: true
	});

	if (key)
		return query[key];
	else
		return query;
}

export async function pushUrl(title, url, data) {
	window.history.pushState(data, title, url);
}

export async function changeUrl(url) {
	window.location.href = url;
}

function serialize(params, prefix) {
	return Object.entries(params).reduce((acc, [key, value]) => {
		// remove whitespace from both sides of the key before encoding
		key = encodeURIComponent(key.trim());

		if (params.constructor === Array) {
			key = `${prefix}[]`;
		} else if (params.constructor === Object) {
			key = (prefix ? `${prefix}[${key}]` : key);
		}

		/**
		 *  - undefined and NaN values will be skipped automatically
		 *  - value will be empty string for functions and null
		 *  - nested arrays will be flattened
		 */
		if (value === null || typeof value === 'function') {
			acc.push(`${key}=`);
		} else if (typeof value === 'object') {
			acc = acc.concat(serialize(value, key));
		} else if (['number', 'boolean', 'string'].includes(typeof value) && value === value) { // self-check to avoid NaN
			acc.push(`${key}=${encodeURIComponent(value)}`);
		}

		return acc;
	}, []);
}

export function objectToQueryString(queryParameters) {
	return queryParameters ? serialize(queryParameters).join('&') : '';
}

export function objectToQueryStringShort(queryParameters) {
	let str = ''
	Object.keys(queryParameters).map(key => {
		if(key === 'ids') {
			str = str + key + '=id...&'
		} else {
			str = str + key + '=' + queryParameters[key] + '&'
		}

	})
	str = str.slice(0, -1);
	return str;
}

export function parseParams(params) {
	const output = {};
	const searchParams = new URLSearchParams(params);

	// Set will return only unique keys()
	new Set([...searchParams.keys()])
	.forEach(key => {
		if (key.indexOf("[]") !== -1) {
			if (searchParams.getAll(key).length > 1) {
				output[key.replace('[]', '')] = searchParams.getAll(key);
			} else {
				output[key.replace('[]', '')] = [];
				output[key.replace('[]', '')].push(searchParams.get(key));
			}
		} else {
			output[key.replace('[]', '')] = searchParams.getAll(key).length > 1 ?
				searchParams.getAll(key) : // get multiple values
				searchParams.get(key); // get single value
		}
		// output[key.replace('[]', '')] = searchParams.getAll(key).length > 1 ?
		//     searchParams.getAll(key) : // get multiple values
		//     searchParams.get(key); // get single value
	});

	return output;
}

export function getObjectLength(object) {
	if (object)
		return Object.keys(object).length;
	else
		return 0;
}

/**
 * @param {Object} query
 */
export const addQuery = (query) => {
	const location = Object.assign({}, browserHistory.getCurrentLocation());

	Object.assign(location.query, query);
	// or simple replace location.query if you want to completely change params

	browserHistory.push(location);
};

/**
 * @param {...String} queryNames
 */
export const removeQuery = (...queryNames) => {
	const location = Object.assign({}, browserHistory.getCurrentLocation());
	queryNames.forEach(q => delete location.query[q]);
	browserHistory.push(location);
};

/**
 *
 * @param args
 * @returns {Promise<*>}
 */
export async function getData(url, args) {
	const options = {
		method: 'GET',
		params: args,
		headers: {
			'X-WP-Nonce': rmVars.api_nonce,
		},
		url: rmVars.restApi + url,
	};
	let response = null;
	await axios(options).then((res) => {
		if (res.data.status)
			response = res.data.result;
	}).catch((error) => {
		// console.log(error)
		// response = null;
	});

	return response;
}

/**
 *
 * @param args
 * @returns {Promise<*>}
 */
export async function updateData(url, args) {
	const options = {
		method: "post",
		data: args,
		headers: {
			'X-WP-Nonce': rmVars.api_nonce,
		},
		url: rmVars.restApi + url,
	};
	let response = null;
	await axios(options).then((res) => {
		if (res.data.status)
			response = res.data.result;
	})
	.catch((error) => {
		// response = null;
	});
	return response;
}

/**
 *
 * @param args
 * @returns {Promise<*>}
 */
export async function updateFile(url, form) {
	let response = null;
	await axios.post(rmVars.restApi + url, form,
		{headers: {'X-WP-Nonce': rmVars.api_nonce}}).then((res) => {
		if(res.status)
			return response = res.data.result;
	})
	.catch((error) => {
		// response = null;
	});
	return response;
}

/**
 *
 * @param args
 * @returns {Promise<*>}
 */
export async function getWpAjax(action, args) {
	let form = new FormData();
	form.append("action", action);
	Object.keys(args).map((key, i) => {
		form.append(key, args[key]);
	});
	let response = null;
	await axios.post(rmVars.ajaxUrl, form).then((res) => {
		if (res.data.records.length > 0)
			response = res.data.records;
	})
	.catch((error) => {
		// response = null;
	});
	return response;
}

export function getDateYMD(date) {
	if(!date)
		return '';
	const t = date.split(' ');
	if(t.length > 1)
		return t[0]
	else
		return date;
}

export function removeParamUrl(key, url = '') {
	// let url = '';
	url = url ? url : window.location.href;
	let tempUrl = new URL(url);
	let search_params = tempUrl.searchParams;
	search_params.delete(key);
	let searchString = decodeURIComponent(search_params.toString());
	url = tempUrl.origin + tempUrl.pathname + (searchString ? '?' : '' ) + searchString;
	return url;
}

export function changeParamUrl(key, value) {
	let url = '';
	let tempUrl = new URL(window.location.href);
	var search_params = tempUrl.searchParams;
	search_params.set(key, value);
	tempUrl.search = search_params.toString();
	var new_url = tempUrl.toString();
	url = "admin.php?" + new_url.split("?")[1];
	return url;
}

export function scrollMove() {
	window.scrollTo({
		behavior: "smooth",
		top: document.getElementById('container').getBoundingClientRect().top -
			document.body.getBoundingClientRect().top - SCROLL_OFFSET
	});
}

export function deepClone(obj) {
	if (obj === null || typeof obj !== "object") {
		return obj
	}

	const result = Array.isArray(obj) ? [] : {}

	for (let key of Object.keys(obj)) {
		result[key] = deepClone(obj[key])
	}

	return result
}

export function setCookie (name, value, day) {
	let date = new Date();
	date.setTime(date.getTime() + day * 60 * 60 * 24 * 1000);
	document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
}

export function getCookie (name) {
	let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return value? value[2] : "";
}